<template>
  <section class="featured-collections">
    <div class="featured-collections__header">
      <div class="featured-collections__header-title">
        {{ titleText }}
      </div>
      <div class="featured-collections__header-collections-link">
        <router-link
          :to="{ name: 'collection-all' }"
          class="featured-collections__header-collections-link-btn btn btn--secondary"
        >
          <span>
            See all
            <span v-if="getWindowWidth() > 768">collections</span>
          </span>
        </router-link>
      </div>
    </div>
    <div
      :class="[
        'featured-collections__collections',
        !isHomepage && 'featured-collections__collections--layout-two',
      ]"
    >
      <div
        :class="[
          'featured-collections__highlighted-collection',
          !isHomepage &&
            'featured-collections__highlighted-collection--layout-two',
        ]"
      >
        <HighlightedFeaturedCollection :smallView="!isHomepage" />
      </div>
      <div
        :class="[
          'featured-collections__cards-list',
          !isHomepage && 'featured-collections__cards-list--layout-two',
        ]"
      >
        <LabsCollectionCard
          v-for="collectionFeatured in featuredCollections"
          :key="collectionFeatured.id"
          :collection="collectionFeatured"
          :lockedContent="lockedContent(collectionFeatured)"
          :showTooltips="false"
          class="featured-collections__cards-list-item"
        />
      </div>
    </div>
  </section>
</template>

<script>
import LabsCollectionCard from '@/components/lab-experience/LabsCollectionCard.vue'
import HighlightedFeaturedCollection from '@/components/lab-experience/HighlightedFeaturedCollection.vue'

import { collectionCommons } from '@/helpers/mixins'

export default {
  name: 'FeaturedCollections',
  components: {
    LabsCollectionCard,
    HighlightedFeaturedCollection,
  },
  mixins: [collectionCommons],
  inject: ['getWindowWidth'],
  props: {
    featuredCollections: {
      type: Array,
      required: true,
    },
    isHomepage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    titleText() {
      return this.isHomepage
        ? 'We have featured collections for you'
        : 'More collections you might like'
    },
  },
}
</script>

<style lang="scss" scoped>
.featured-collections {
  display: flex;
  flex-wrap: wrap;
  color: var(--white);
  gap: 30px;

  &__header {
    display: flex;
    gap: 10px;
    justify-content: space-between;
    width: 100%;

    &-title {
      font-size: rem(18px);
      font-weight: 500;
      line-height: rem(24px);
      text-align: left;
      margin-bottom: 30px;

      @include tablet {
        font-size: rem(24px);
        line-height: rem(32px);
        font-weight: 450;
        margin-bottom: 35px;
      }
    }

    &-collections {
      &-link-btn {
        padding: 8px 16px;

        @include mobile {
          padding: 12px 24px;
        }
      }
    }
  }
  &__cards-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    overflow: auto;
    white-space: nowrap;
    @include desktop {
      display: grid;
      grid-template-columns: 1fr;
      white-space: unset;
      overflow: auto;
      justify-content: center;
      row-gap: 20px;
    }
    &--layout-two {
      grid-template-columns: repeat(3, 1fr);
      .labs-collection-card {
        @include desktop {
          max-height: unset !important;
        }
      }
    }
  }
  &__highlighted-collection {
    width: 100%;
    &--layout-two {
      @include mobile {
        grid-area: 1 / 1 / 2 / 2;
      }
    }
  }
  &__collections {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    @include desktop {
      grid-template-columns: 1fr 400px;
      width: 100%;
      display: grid;
      white-space: unset;
      overflow: auto;
      justify-content: center;
      row-gap: 20px;
    }
    &--layout-two {
      @include mobile {
        grid-template: repeat(2, auto) / 1fr;
      }
    }
  }
}
</style>
